import React from "react";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { CheckCircle2, XCircle, Copy, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

const CAN = [
  "Share your branded referral link and personal landing page",
  "Use pre-approved email, SMS, and social media templates",
  "Post about PMB Loans on social media using supplied content",
  "Track the status of borrower applications you've referred or submitted",
  "Submit borrower applications on their behalf through the portal",
  "Distribute program rate sheets provided by PMB Loans",
];
const CANNOT = [
  "Originate, negotiate, or advise on the terms of any loan",
  "Quote specific rates, points, or loan terms directly to borrowers",
  "Accept applications, documents, or payments outside the portal",
  "Promise loan approvals or guarantee funding",
  "Represent yourself as a licensed loan officer or broker of record",
  "Modify pre-approved marketing content without approval",
];

const DISCLOSURE = "I am a marketing partner of PMB Loans. I do not originate, negotiate, or advise on loans. All lending activities are handled by PMB Loans's licensed team.";

export default function SponsorTraining() {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(DISCLOSURE);
      toast.success("Disclosure copied");
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight">Training & Compliance</h1>
        <p className="mt-1 text-sm text-slate-400">Stay within the lines, stay in business.</p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Card className="border-slate-800 bg-slate-900 p-6" data-testid="training-can-card">
          <div className="mb-4 flex items-center gap-2">
            <CheckCircle2 className="h-4 w-4 text-emerald-400" />
            <div className="text-sm font-semibold text-emerald-300">What Brokers CAN Do</div>
          </div>
          <ul className="space-y-3">
            {CAN.map((c) => (
              <li key={c} className="flex items-start gap-3 text-sm text-slate-200">
                <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-400" />
                {c}
              </li>
            ))}
          </ul>
        </Card>
        <Card className="border-slate-800 bg-slate-900 p-6" data-testid="training-cannot-card">
          <div className="mb-4 flex items-center gap-2">
            <XCircle className="h-4 w-4 text-rose-400" />
            <div className="text-sm font-semibold text-rose-300">What Brokers CANNOT Do</div>
          </div>
          <ul className="space-y-3">
            {CANNOT.map((c) => (
              <li key={c} className="flex items-start gap-3 text-sm text-slate-200">
                <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-rose-400" />
                {c}
              </li>
            ))}
          </ul>
        </Card>
      </div>

      <Card className="border-slate-800 bg-slate-900 p-6" data-testid="disclosure-card">
        <div className="mb-4 flex items-center gap-2">
          <ShieldCheck className="h-4 w-4 text-emerald-400" />
          <div className="text-sm font-semibold">Required Disclosure</div>
        </div>
        <div className="rounded-md border border-slate-800 bg-slate-950 p-5 text-sm text-slate-200">
          "{DISCLOSURE}"
        </div>
        <Button onClick={copy} className="mt-4 bg-emerald-600 text-white hover:bg-emerald-500" data-testid="copy-disclosure-btn">
          <Copy className="mr-2 h-3 w-3" /> Copy disclosure
        </Button>
      </Card>
    </div>
  );
}
